import { defineStore } from 'pinia'
import type { ManagerBenefitGetListRequest } from '@/models/api/manager-benefit-get-list-request'

export const useCheckBoxTypeStore = defineStore('check-box-type', () => {
  const _checkBoxFormData = ref<ManagerBenefitGetListRequest | null>({
    type: [],
    tag: []
  })

  /** checkBox FormData */
  const checkBoxFormData = computed(() => {
    return _checkBoxFormData.value
  })

  /** 設定 checkBox FormData */
  const setCheckBoxFormData = (data: ManagerBenefitGetListRequest | null) => {
    _checkBoxFormData.value = data
  }

  /** 清空 checkBox FormData */
  const clearCheckBoxFormData = () => {
    _checkBoxFormData.value = null
  }

  return { checkBoxFormData, setCheckBoxFormData, clearCheckBoxFormData }
})
